document.querySelectorAll('.stage-video:not(.stage-video--image)').forEach((wrap) => {
  const video = wrap.querySelector('.stage-video__video__inner__video');
  const play = wrap.querySelector('.stage-video__play');

  // Play/Pause
  const playPauseVideo = () => {
    if (video.paused) {
      play.setAttribute('data-icon', 'pause');
      video.play();
    } else {
      play.setAttribute('data-icon', 'play');
      video.pause();
    }
  };
  play.addEventListener('click', playPauseVideo);
});
